define('models/payment/invoice',[
    'backbone', 'moment', 'services/user'

], function(
    Backbone, moment, User
) {

    var MInvoice = Backbone.Epoxy.Model.extend({
        idAttribute: 'id',

        getTransactionId: function() {
            return this.get('id');
        },

        getDate: function() {
            return this.get('date');
        },

        getFormatedDate: function() {
            return moment(this.get('date')).format('YYYY-MM-DD h:mm');
        },

        getFormatedShortDate: function() {
            return moment(this.get('date')).format('YYYY-MM-DD');
        },

        getCurrency: function() {
            return this.get('currency');
        },

        getTotalPaid: function() {
            return this.get('total');
        },

        getFormatedTotal: function() {
            var languageCode = User.get('languageCode') === undefined ? 'USD' : User.get('languageCode');

            var currencyFormatter = new Intl.NumberFormat(languageCode, {
                style: 'currency',
                currency: this.get('currency'),
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            return currencyFormatter.format(this.get('total') / 100);
        }
    });

    // Return the model for the module
    return MInvoice;
});

